import { Button } from 'antd';
import { InputFromUser } from '../../components/Input/input';
import { Options } from '../../utils/Data';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { useDispatch } from 'react-redux';
import { ActionGetMedicineList } from '../../store/Actions/PatientAction';

const PrescriptionTable = ({
  values,
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
  handleChange,
  handleBlur,
  IsFilledForm,
  medicineList,
  loader,
}) => {
  const dispatch = useDispatch();

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="card">
          <div className="card-body p-3">
            <div className="mb-3">
              <h4 style={{ color: '#111827', fontWeight: '700', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <FeatherIcon icon="file-plus" size="20" style={{ color: '#4f46e5' }} />
                Prescription
              </h4>
            </div>
            <div className="invoice-add-table form-group">
              <div className="table-responsive">
                <table className="table table-center add-table-items prescription-table">
                  <thead>
                    <tr>
                      <th className="medicine-col">Medicine</th>
                      <th className="when-col">When to Take</th>
                      <th className="quantity-col">Quantity</th>
                      <th className="course-col">Course Duration</th>
                      <th className="anupan-col">Anupan</th>
                      <th className="days-col">Days</th>
                      <th className="text-end actions-col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {values?.recomendedMedicines?.map((item, index) => {
                      return (
                        <tr key={'Medicines' + index + 'tr'} className="prescription-row">
                          <td
                            className="medicine-col"
                            key={'Medicines' + index + 'td'}
                            style={{
                              borderColor:
                                errors?.recomendedMedicines?.[index]
                                  ?.medicineName &&
                                touched.recomendedMedicines?.[index]
                                  ?.medicineName &&
                                'red',
                              minWidth: '150px',
                            }}
                          >
                            {
                              <InputFromUser
                                type="singleSelect"
                                label=""
                                key={'MedicinesName' + index}
                                Showlabel={false}
                                mode={''}
                                name="recomendedMedicines"
                                onChange={v => {
                                  const updateArry = Object.assign(
                                    [],
                                    values.recomendedMedicines
                                  );
                                  updateArry[index] = {
                                    ...updateArry[index],
                                    ...{ medicineName: v },
                                  };
                                  setFieldValue(
                                    'recomendedMedicines',
                                    updateArry,
                                    true
                                  );
                                }}
                                FormControlClassName={'form-control'}
                                value={item?.medicineName}
                                disabled={IsFilledForm}
                                onSearch={search => {
                                  if (search.length >= 2) {
                                    dispatch(
                                      ActionGetMedicineList({
                                        Query: `?name=${search}`,
                                      })
                                    );
                                  } else if (search.length === 0) {
                                    dispatch(ActionGetMedicineList({ Query: `` }));
                                  }
                                }}
                                onBlur={() => {
                                  const updateArry = Object.assign(
                                    [],
                                    touched.recomendedMedicines
                                  );
                                  updateArry[index] = {
                                    ...updateArry[index],
                                    ...{ medicineName: true },
                                  };
                                  setFieldTouched(
                                    'recomendedMedicines',
                                    updateArry,
                                    true
                                  );
                                }}
                                error={
                                  errors?.recomendedMedicines?.[index]?.medicineName
                                }
                                touched={
                                  touched?.recomendedMedicines?.[index]
                                    ?.medicineName
                                }
                                onSearchLoading={loader}
                                options={
                                  medicineList.length != 0
                                    ? medicineList?.map(item => item?.name)
                                    : []
                                }
                                placeholder={'Enter Your Medicines'}
                              />
                            }
                          </td>
                          <td className="when-col" key={'td2' + index} style={{ minWidth: '120px' }}>
                            {
                              <InputFromUser
                                type="multiple"
                                label=""
                                Showlabel={false}
                                mode={''}
                                disabled={IsFilledForm}
                                name="whenToTake"
                                onChange={v => {
                                  const updateArry = Object.assign(
                                    [],
                                    values.recomendedMedicines
                                  );
                                  updateArry[index] = {
                                    ...updateArry[index],
                                    ...{ whenToTake: v },
                                  };
                                  setFieldValue(
                                    'recomendedMedicines',
                                    updateArry,
                                    true
                                  );
                                }}
                                FormControlClassName={'form-control'}
                                value={item?.whenToTake}
                                onSearch={search => {
                                  if (search.length >= 3) {
                                    dispatch(
                                      ActionGetMedicineList({
                                        Query: `?name=${search}`,
                                      })
                                    );
                                  } else if (search.length === 0) {
                                    dispatch(ActionGetMedicineList({ Query: `` }));
                                  }
                                }}
                                onBlur={() => {
                                  const updateArry = Object.assign(
                                    [],
                                    touched.recomendedMedicines
                                  );
                                  updateArry[index] = {
                                    ...updateArry[index],
                                    ...{ whenToTake: true },
                                  };
                                  setFieldTouched(
                                    'recomendedMedicines',
                                    updateArry,
                                    true
                                  );
                                }}
                                error={
                                  errors?.recomendedMedicines?.[index]?.whenToTake
                                }
                                touched={
                                  touched?.recomendedMedicines?.[index]?.whenToTake
                                }
                                onSearchLoading={loader}
                                options={Options.WhenToTakeMedicine}
                                placeholder={'Enter When to Take'}
                              />
                            }
                          </td>
                          <td className="quantity-col" key={'td3' + index} style={{ minWidth: '100px' }}>
                            <div>
                              <InputFromUser
                                type="text"
                                label=""
                                disabled={IsFilledForm}
                                Showlabel={false}
                                mode={''}
                                name="howMuch"
                                onChange={v => {
                                  const numericValue = parseFloat(v?.target?.value);

                                  if (
                                    !isNaN(numericValue) &&
                                    isFinite(numericValue)
                                  ) {
                                    const updateArry = Object.assign(
                                      [],
                                      values.recomendedMedicines
                                    );
                                    updateArry[index] = {
                                      ...updateArry[index],
                                      ...{ howMuch: numericValue },
                                    };
                                    setFieldValue(
                                      'recomendedMedicines',
                                      updateArry,
                                      true
                                    );
                                  }
                                }}
                                FormControlClassName={'form-control'}
                                value={item?.howMuch}
                                error={
                                  errors?.recomendedMedicines?.[index]?.howMuch
                                }
                                touched={
                                  touched?.recomendedMedicines?.[index]?.howMuch
                                }
                                onSearchLoading={loader}
                                onBlur={() => {
                                  const updateArry = Object.assign(
                                    [],
                                    touched.recomendedMedicines
                                  );
                                  updateArry[index] = {
                                    ...updateArry[index],
                                    ...{ howMuch: true },
                                  };
                                  setFieldTouched(
                                    'recomendedMedicines',
                                    updateArry,
                                    true
                                  );
                                }}
                                placeholder={'Enter Quantity'}
                              />
                            </div>
                          </td>

                          <td className="course-col" key={'td4' + index} style={{ minWidth: '130px' }}>
                            {
                              <InputFromUser
                                type="singleSelect"
                                label=""
                                Showlabel={false}
                                mode={''}
                                disabled={IsFilledForm}
                                name="course"
                                onChange={v => {
                                  const updateArry = Object.assign(
                                    [],
                                    values.recomendedMedicines
                                  );
                                  updateArry[index] = {
                                    ...updateArry[index],
                                    ...{ course: v },
                                  };
                                  setFieldValue(
                                    'recomendedMedicines',
                                    updateArry,
                                    true
                                  );
                                }}
                                FormControlClassName={'form-control'}
                                value={item?.course}
                                onSearch={search => {
                                  if (search.length >= 3) {
                                    dispatch(
                                      ActionGetMedicineList({
                                        Query: `?name=${search}`,
                                      })
                                    );
                                  } else if (search.length === 0) {
                                    dispatch(ActionGetMedicineList({ Query: `` }));
                                  }
                                }}
                                onBlur={() => {
                                  const updateArry = Object.assign(
                                    [],
                                    touched.recomendedMedicines
                                  );
                                  updateArry[index] = {
                                    ...updateArry[index],
                                    ...{ course: true },
                                  };
                                  setFieldTouched(
                                    'recomendedMedicines',
                                    updateArry,
                                    true
                                  );
                                }}
                                error={errors?.recomendedMedicines?.[index]?.course}
                                touched={
                                  touched?.recomendedMedicines?.[index]?.course
                                }
                                onSearchLoading={loader}
                                options={Options.CourseDuration}
                                placeholder={'Enter Course Duration'}
                              />
                            }
                          </td>

                          <td className="anupan-col" key={'td5' + index} style={{ minWidth: '120px' }}>
                            {
                              <InputFromUser
                                type="singleSelect"
                                label=""
                                disabled={IsFilledForm}
                                Showlabel={false}
                                mode={''}
                                name="anupan"
                                onChange={v => {
                                  const updateArry = Object.assign(
                                    [],
                                    values.recomendedMedicines
                                  );
                                  updateArry[index] = {
                                    ...updateArry[index],
                                    ...{ anupan: v },
                                  };
                                  setFieldValue(
                                    'recomendedMedicines',
                                    updateArry,
                                    true
                                  );
                                }}
                                FormControlClassName={'form-control'}
                                value={item?.anupan}
                                error={errors?.recomendedMedicines?.[index]?.anupan}
                                touched={
                                  touched?.recomendedMedicines?.[index]?.anupan
                                }
                                onSearchLoading={loader}
                                onBlur={() => {
                                  const updateArry = Object.assign(
                                    [],
                                    touched.recomendedMedicines
                                  );
                                  updateArry[index] = {
                                    ...updateArry[index],
                                    ...{ anupan: true },
                                  };
                                  setFieldTouched(
                                    'recomendedMedicines',
                                    updateArry,
                                    true
                                  );
                                }}
                                options={Options.Anupana}
                                placeholder={'Enter Your anupan'}
                              />
                            }
                          </td>
                          <td className="days-col" key={'td6' + index} style={{ minWidth: '80px' }}>
                            {
                              <InputFromUser
                                type="number"
                                label=""
                                Showlabel={false}
                                mode={''}
                                name="days"
                                onChange={v => {
                                  const updateArry = Object.assign(
                                    [],
                                    values.recomendedMedicines
                                  );
                                  updateArry[index] = {
                                    ...updateArry[index],
                                    ...{ days: v?.target?.value },
                                  };
                                  setFieldValue(
                                    'recomendedMedicines',
                                    updateArry,
                                    true
                                  );
                                }}
                                FormControlClassName={'form-control'}
                                value={item?.days}
                                touched={
                                  touched?.recomendedMedicines?.[index]?.days
                                }
                                onSearchLoading={loader}
                                onBlur={() => {
                                  const updateArry = Object.assign(
                                    [],
                                    touched.recomendedMedicines
                                  );
                                  updateArry[index] = {
                                    ...updateArry[index],
                                    ...{ days: true },
                                  };
                                  setFieldTouched(
                                    'recomendedMedicines',
                                    updateArry,
                                    true
                                  );
                                }}
                                placeholder={'Enter Days'}
                              />
                            }
                          </td>

                          <td
                            className="add-remove text-end align-items-center actions-col"
                            key={'td7' + index}
                            style={{ minWidth: '100px' }}
                          >
                            <Button
                              className="add-btn border-0"
                              disabled={IsFilledForm}
                              onClick={() => {
                                const newValue = {
                                  medicineName: '',
                                  days: item?.days,
                                  whenToTake: '',
                                  anupan: '',
                                  howMuch: '',
                                };
                                setFieldValue('recomendedMedicines', [
                                  ...values.recomendedMedicines,
                                  newValue,
                                ]);
                              }}
                            >
                              <i className="fas fa-plus-circle" />
                            </Button>
                            <Button
                              className="remove-btn border-0"
                              disabled={IsFilledForm}
                              onClick={() => {
                                if (index !== 0) {
                                  const updatedMedicines = [
                                    ...values.recomendedMedicines,
                                  ];
                                  updatedMedicines.splice(index, 1);
                                  setFieldValue(
                                    'recomendedMedicines',
                                    updatedMedicines
                                  );
                                }
                              }}
                            >
                              <i className="fe fe-trash-2">
                                <FeatherIcon icon="trash-2" className={'mb-1'} />
                              </i>
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrescriptionTable;

<style>{`
  @media (max-width: 768px) {
    .prescription-table {
      font-size: 14px;
    }
    .prescription-table th,
    .prescription-table td {
      padding: 8px 4px;
    }
    .prescription-table .medicine-col {
      min-width: 140px !important;
    }
    .prescription-table .when-col {
      min-width: 110px !important;
    }
    .prescription-table .quantity-col {
      min-width: 90px !important;
    }
    .prescription-table .course-col {
      min-width: 120px !important;
    }
    .prescription-table .anupan-col {
      min-width: 110px !important;
    }
    .prescription-table .days-col {
      min-width: 70px !important;
    }
    .prescription-table .actions-col {
      min-width: 90px !important;
    }
    .prescription-table .add-btn,
    .prescription-table .remove-btn {
      padding: 6px 10px;
      font-size: 16px;
    }
    .prescription-table .form-control {
      font-size: 14px;
      padding: 6px 8px;
    }
  }
  @media (max-width: 576px) {
    .table-responsive {
      border-radius: 8px;
      border: 1px solid #dee2e6;
    }
    .prescription-table {
      font-size: 13px;
    }
    .prescription-table th {
      white-space: nowrap;
    }
  }
`}</style>